import { render, staticRenderFns } from "./SortByMenu.vue?vue&type=template&id=462b9d74&lang=pug&"
import script from "./SortByMenu.vue?vue&type=script&lang=js&"
export * from "./SortByMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports